import { useMutation } from "@tanstack/react-query";
import checkInAppointment from "../../controllers/appointments/checkin-appointment";

const useCheckInAppointment = () => {
  return useMutation(checkInAppointment, {});
};

export default useCheckInAppointment;
